export function calculateRequeueButtonPos(parentElementRectangle, requeueHeightInPx) {
    const left = parentElementRectangle.right - 8; // Overlap the right edge by 8px
    // Vertically center the requeue button by comparing its size to the trade row button
    //    and adjusting the placement up or down.  E.g., if the requeue button height is
    //    64px and the trade menu button is 52 px, then we'd want the top of the requeue
    //    button to be (64 - 52) / 2 = 6px higher than the top of the trade menu button.
    const buttonHeightDiff = requeueHeightInPx - parentElementRectangle.height;
    const buttonTopAdjustment = buttonHeightDiff / 2.0;
    const top = parentElementRectangle.top - buttonTopAdjustment;
    return { left, top };
}
//# sourceMappingURL=requeue-utils.js.map